import { Form, FormField, FormSection, FormType } from '../../../../../common/components/reactive-form-builder/interfaces/form.interface';
import { SectoresEnvironmentDefinition } from '../environment-variables';
import { SectoresListsDefinition } from './list-variables';
import { StorageManager } from '../../../../../common/storage-manager.class';
import { FormRequestTypes } from '../../../../../common/components/reactive-form-builder/form-request';
import { InputType } from '../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { SectorModel } from 'src/app/models/form-common/sector.model';

export class SectoresFormDefinition {    
  public formType!: FormType;

  public env: SectoresEnvironmentDefinition = new SectoresEnvironmentDefinition();

  public lists: SectoresListsDefinition = new SectoresListsDefinition();

  public usuario = StorageManager.getUser();

  public cliente = StorageManager.getClient();

  public model: SectorModel = {} as SectorModel;
    
  public formFieldsSection!: FormSection<object>;
    
  public formFields!: Form<SectorModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];


  constructor(
    type: FormRequestTypes, 
    _model: Record<string,string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;
        
    const action = this.formType === FormType.CREATION ? 'Crear' : 'Actualizar';
    
    this.formFields = {
      name: 'sectores',
      header: action + ' ' + this.env.sectorName,
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: {
        isEnabled: false,
        label: ''
      },
      signed: false
    };
  }


  public getFormFields(): FormField<any>[] {
    const formFields: FormField<any>[] = [
      {
          name: this.formType < 3 ? 'id_finca' : 'finca',
          vinculatedFields: undefined,
          label: this.env.fincaName,
          input: {
            type: InputType.DROPDOWN, 
            isEditable: true, 
            data: this.lists.fincas,
            dropdownConfiguration: {valuePrimaryKey: 'id'}
          },
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: true,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true
          },
          order: 1
        },
        {
          name: 'nombre',
          vinculatedFields: undefined,
          label: `Nombre ${this.env.sectorName}`, 
          input: {type: InputType.TEXT, isEditable: true}, 
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: true,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true
          },
          order: 2
        },
        {
          name: this.formType < 3 ? 'id_jardin' : 'jardin',
          vinculatedFields: undefined,
          label: 'Jardín',
          input: {
            type: InputType.DROPDOWN, 
            isEditable: true,
            data: this.lists.jardines,
            dropdownConfiguration: {valuePrimaryKey: 'id'}
          },
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName === 'detorres'
          },
          order: 3
        },
        {
          name: 'partida',
          vinculatedFields: undefined, 
          label: 'Partida', 
          input: {type: InputType.TEXT, isEditable: true}, 
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.showPartida
          },
          order: 4
        },
        {
          name: 'goteros',
          vinculatedFields: undefined, 
          label: 'Nº Goteros/Árbol',
          input: {type: InputType.TEXT, isEditable: true},
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName !== 'gardengest'
          },
          order: 5
        },
        {
          name: 'caudal_gotero', 
          vinculatedFields: undefined,
          label: 'Caudal Gotero (l/h)', 
          input: {type: InputType.TEXT, isEditable: true}, 
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName !== 'gardengest'
          },
          order: 6
        },
        {
          name: 'caudal_cuba', 
          vinculatedFields: undefined,
          label: 'Capacidad Cuba (l)', 
          input: {type: InputType.TEXT, isEditable: true},
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName !== 'gardengest'
          },
          order: 7
        },
        {
          name: 'caudal_inyectora',
          vinculatedFields: undefined, 
          label: 'Caudal Inyectora (l/h)', 
          input: {type: InputType.TEXT, isEditable: true},
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName !== 'gardengest'
          },
          order: 8
        },
        {
          name: 'distancia_goteros',
          vinculatedFields: undefined,
          label: 'Distancia entre Goteros',   
          input: {
            type: InputType.TEXT, 
            isEditable: true,
            data: this.lists.distanciasGoteros
          },
          width: 3, 
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName === 'benibal'
          },
          order: 9
        },
        {
          name: 'sup_cultivada', 
          vinculatedFields: undefined,
          label: 'S.\xa0cultivada\xa0(' + this.env.textoSuperficie + ')',
          input: {type: InputType.TEXT, isEditable: true},
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName !== 'gardengest' && this.formType >= 3
          },
          order: 10
        },
        {
          name: 'total_plantas', 
          vinculatedFields: undefined,
          label: 'Nº\xa0Plantas', 
          input: {type: InputType.TEXT, isEditable: false},
          width: 3,
          conditions: {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: this.env.appName !== 'gardengest' && this.formType >= 3
          },
          order: 11
        },
    ];

    this.fieldNames = this.fieldNames.concat(formFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getHiddenFields(): FormField<any>[] {
    const hiddenFields: FormField<any>[] = [
      {
        name: 'id',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.model.id,
          isEditable: false
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'id_cliente',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.cliente?.id !== null ? this.cliente?.id : this.lists.fincas.selected?.id_cliente,
          isEditable: false
        },
        updateValue: () => this.cliente?.id !== null ? this.cliente?.id : this.lists.fincas.selected?.id_cliente,
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasClients
        },
        order: 2
      },
      {
        name: 'id_usuario',
        vinculatedFields: undefined,
        label: '',
        input: {
          isEditable: false,
          defaultValue: this.env.applicationType === 'cropgest'
                    ? this.cliente?.id_usuario ?? this.usuario.id
                    : this.cliente?.id_usuario_asignado ??
                      this.model.id_usuario ?? this.usuario.id,
          type: InputType.HIDDEN,
        },
        updateValue: () =>  this.env.applicationType === 'cropgest'
                    ? this.cliente?.id_usuario ?? this.usuario.id
                    : this.cliente?.id_usuario_asignado ??
                      this.model.id_usuario ?? this.usuario.id,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 3
      },
    ];

    this.fieldNames = this.fieldNames.concat(hiddenFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(hiddenFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
    

  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 2
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
}